type TreeNode = number | TreeNode[];

export const parseStringToArray = (input: string): TreeNode[] => {
  let index = 0;

  const parseLevel = (): TreeNode[] => {
    const result: TreeNode[] = [];
    let currentNumber = '';

    while (index < input.length) {
      const char = input[index];

      if (char === '[') {
        if (currentNumber) {
          result.push(parseFloat(currentNumber));
          currentNumber = '';
        }

        index++;

        const nested = parseLevel(); // this will parse everything up until the next ']'
        result.push(nested);
      } else if (char === ']') {
        if (currentNumber) {
          result.push(parseFloat(currentNumber));
          currentNumber = '';
        }
        index++; // skip ']'
        return result;
      } else if (char === ' ') {
        if (currentNumber) {
          result.push(parseFloat(currentNumber));
          currentNumber = '';
        }
        index++;
      } else {
        currentNumber += char;
        index++;
      }
    }

    if (currentNumber) {
      result.push(parseFloat(currentNumber));
      currentNumber = '';
    }

    return result;

  }

  return parseLevel();
}

export const flattenToTimeline = (tree: TreeNode[], slotDuration: number, startOffset: number = 0): Array<[number, number]> => {
  const result: Array<[number, number]> = [];
  const itemDuration = slotDuration / tree.length;

  tree.forEach((node, i) => {
    const itemStart = startOffset + (itemDuration * i);

    if (typeof node === 'number') {
      result.push([node, itemStart + itemDuration])
    } else if (Array.isArray(node)) {
      const nested = flattenToTimeline(node, itemDuration, itemStart);
      result.push(...nested);
    }
  });

  return result;
}